import type { PriorityFix } from "@/api/classroom-render";
import { SECTION_TITLE, OWNER_COLORS, FIX_TYPE_COLORS, slugify, ownerForCategory } from "./config";

export function PriorityFixes({ fixes, subToCat }: { fixes: PriorityFix[]; subToCat: Map<string, string> }) {
  if (fixes.length === 0) return null;

  return (
    <div>
      <h2 className={`${SECTION_TITLE} mb-3`}>Priority Fixes</h2>
      <div className="flex flex-col gap-3">
        {fixes.map((fix, i) => {
          const cat = subToCat.get(fix.subcategory);
          const owner = cat ? ownerForCategory(cat) : "Triage";
          const ownerColors = OWNER_COLORS[owner] ?? OWNER_COLORS["Triage"];
          const anchor = cat ? `#${slugify(cat)}__${slugify(fix.subcategory)}` : undefined;
          return (
            <div key={i} className="rounded-md border border-border bg-card p-3 flex flex-col gap-1.5">
              <div className="flex items-center gap-2 flex-wrap">
                {anchor ? (
                  <a href={anchor} className="text-sm font-semibold text-primary hover:underline underline-offset-2">{fix.subcategory}</a>
                ) : (
                  <span className="text-sm font-semibold text-foreground">{fix.subcategory}</span>
                )}
                <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${ownerColors.bg} ${ownerColors.text}`}>
                  {owner}
                </span>
                {fix.is_most_fundamental && (
                  <span className={`text-xs font-semibold rounded px-1.5 py-0.5 ${FIX_TYPE_COLORS.fundamental}`}>
                    Most Fundamental
                  </span>
                )}
                {fix.is_easy_fix && (
                  <span className={`text-xs font-semibold rounded px-1.5 py-0.5 ${FIX_TYPE_COLORS.easy}`}>
                    Easy Fix
                  </span>
                )}
              </div>
              <p className="text-sm text-foreground leading-snug">{fix.suggested_fix}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
